 ///       table 大数据渲染自定义指令
 // 设置默认溢出显示数量
var spillDataNum = 20;

// 设置隐藏函数
var timeout = false;
let setRowDisableNone = function (topNum, showRowNum, binding) {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    binding.value.call(null, topNum, topNum + showRowNum + spillDataNum);
  });
};

export default {
  name: 'loadmore',
  componentUpdated: function (el, binding, vnode, oldVnode) {
    setTimeout(() => {
    	//console.log(vnode.data,oldVnode.data)
      const dataSize = vnode.data.attrs['data-size'];
      let oldDataSize=0;
      if(oldVnode.data.attrs) {
      	oldDataSize = oldVnode.data.attrs['data-size'];
      }
       
      if(dataSize === oldDataSize){
        return;
      }
      const selectWrap = el.querySelector('.el-table__body-wrapper');
      const selectTbody = selectWrap.querySelector('table tbody');
      const selectRow = selectWrap.querySelector('table tr');
      if (!selectRow) {
        return;
      }
      const rowHeight = selectRow.clientHeight;  // 获取单个行高度
      let showRowNum = Math.round(selectWrap.clientHeight / rowHeight);  // 获取当前显示行的数量

      const createElementTR = document.createElement('tr');  // 创建行
      let createElementTRHeight = (dataSize - showRowNum - spillDataNum) * rowHeight;  // 获取创建行高度
      createElementTR.setAttribute('style', `height: ${createElementTRHeight}px;`);  // 设置高度
      selectTbody.append(createElementTR);   // 添加当前行

      // 监听滚动后事件
      selectWrap.addEventListener('scroll', function () {
        let topPx = this.scrollTop - spillDataNum * rowHeight;
        let topNum = Math.round(topPx / rowHeight);
        let minTopNum = dataSize - spillDataNum - showRowNum;
        if (topNum > minTopNum) {
          topNum = minTopNum;
        }
        if (topNum < 0) {
          topNum = 0;
          topPx = 0;
        }
        selectTbody.setAttribute('style', `transform: translateY(${topPx}px)`);
        createElementTR.setAttribute('style', `height: ${createElementTRHeight-topPx > 0 ? createElementTRHeight-topPx : 0}px;`);
        setRowDisableNone(topNum, showRowNum, binding);
      })
    });
  }
};


// WEBPACK FOOTER //
// ./src/assets/utils/randerTable.js